export const assembleAddress = ({ street, city, state, zip }) => {
    let parts = [];
    if (street) parts.push(String(street).trim());
    if (city) parts.push(String(city).trim());
    if (state) parts.push(String(state).trim());
    if (zip) parts.push(String(zip).trim());
    return parts.join(", ");
  };
  